module.exports = __webpack_public_path__ + "cfaed8a5adc82829d30c37f4606b30c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-32x32.png
// module id = 1774
// module chunks = 55